module.exports = __webpack_public_path__ + "1793882494189/images/africa.7bf519d.png";